// ════════════════════════════════════════════════════════════
// FichajeOlvidado — registrar la jornada de un día que no se fichó
// ════════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import {
  Box, Alert, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Grid, Typography, Chip
} from '@mui/material';
import { getDiasSinFichar, ficharDiaOlvidado } from '../api';

export default function FichajeOlvidado({ onRegistrado }: any) {
  const [dias, setDias] = useState<string[]>([]);
  const [form, setForm] = useState<any>(null);
  const [guardando, setGuardando] = useState(false);

  const cargar = () => {
    getDiasSinFichar().then(setDias).catch(() => setDias([]));
  };
  useEffect(() => { cargar(); }, []);

  const abrir = (fecha: string) => setForm({
    fecha, hora_entrada: '08:00', hora_salida: '17:00',
    hora_inicio_pausa: '', hora_fin_pausa: '', motivo: '', notas: '',
  });

  const guardar = async () => {
    if (!form.motivo.trim()) { alert('Indica por qué se registra fuera de plazo'); return; }
    setGuardando(true);
    try {
      const r = await ficharDiaOlvidado(form);
      alert(`✅ Jornada registrada: ${r.horas} horas.`);
      setForm(null);
      cargar();
      if (onRegistrado) onRegistrado();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al registrar la jornada');
    } finally {
      setGuardando(false);
    }
  };

  const enEspanol = (f: string) => {
    const d = new Date(f + 'T12:00:00');
    return d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  if (dias.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning">
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
          {dias.length === 1 ? 'Falta un fichaje' : `Faltan ${dias.length} fichajes`}
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
          {dias.map(f => (
            <Chip key={f} label={enEspanol(f)} size="small" color="warning"
              onClick={() => abrir(f)} sx={{ cursor: 'pointer' }} />
          ))}
        </Box>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
          Pulsa en un día para registrarlo. Si no trabajaste, déjalo como está.
        </Typography>
      </Alert>

      <Dialog open={!!form} maxWidth="xs" fullWidth
        onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') setForm(null); }}>
        <DialogTitle>🕐 Registrar jornada</DialogTitle>
        <DialogContent>
          {form && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 2, textTransform: 'capitalize' }}>
                {enEspanol(form.fecha)}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="time" label="Entrada"
                    InputLabelProps={{ shrink: true }} value={form.hora_entrada}
                    onChange={(e) => setForm({ ...form, hora_entrada: e.target.value })} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="time" label="Salida"
                    InputLabelProps={{ shrink: true }} value={form.hora_salida}
                    onChange={(e) => setForm({ ...form, hora_salida: e.target.value })} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="time" label="Inicio de pausa"
                    InputLabelProps={{ shrink: true }} value={form.hora_inicio_pausa}
                    onChange={(e) => setForm({ ...form, hora_inicio_pausa: e.target.value })} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" type="time" label="Fin de pausa"
                    InputLabelProps={{ shrink: true }} value={form.hora_fin_pausa}
                    onChange={(e) => setForm({ ...form, hora_fin_pausa: e.target.value })} />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="Motivo *" value={form.motivo}
                    placeholder="Ej: olvidé fichar al salir de la obra"
                    onChange={(e) => setForm({ ...form, motivo: e.target.value })} />
                </Grid>
              </Grid>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1.5 }}>
                Quedará registrado como añadido fuera de plazo, con la fecha en que lo registras.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setForm(null)}>Cancelar</Button>
          <Button variant="contained" onClick={guardar} disabled={guardando} sx={{ bgcolor: '#4f46e5' }}>
            {guardando ? 'Guardando...' : 'Registrar'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}